<template>
  <div id="data-list-list-view" class="data-list-container">
    <key-project-side-view
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
      @onKeyProjectUpdated="keyProjectUpdated"
      @onKeyProjectInserted="keyProjectInserted"
    />
    <vx-card ref="listCard" :title="$t('KPU.KeyProject.Title')" title-color="black" refresh-content-action @refresh="refreshKeyProjectList">
      <vs-row vs-type="flex" vs-justify="space-between">
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" class="m-3" >
          <vx-tooltip :text="$t('AddNew')" position="bottom" delay=".3s">
            <feather-icon icon="PlusCircleIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" @click="addNewData" />
          </vx-tooltip>
        </vs-col>
      </vs-row>
      <ag-grid-vue
      ref="agGridTable"
      :components="components"
      :gridOptions="gridOptions"
      :context="context"
      class="ag-theme-material w-100 my-4 ag-grid-table"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="keyProjectList"
      rowSelection="single"
      :suppressRowDeselection="true"
      colResizeDefault="shift"
      :animateRows="true"
      :pagination="false"
      :suppressPaginationPanel="true"
      :enableCellChangeFlash="false"
      :enableRtl="$vs.rtl"></ag-grid-vue>
    </vx-card>
  </div>
</template>
<script>

import { AgGridVue } from "ag-grid-vue";
import { BooleanCell } from "../../../shared/components";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import Vue from "vue";
import keyProjectSideView from "./components/keyProjectSideView.vue";
import keyProjectActionsCellRenderer from './components/KeyProjectActionsCellRenderer.vue'
import moduleKpu from "./../store/moduleKpu.js";

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
    AgGridVue,
    BooleanCell,
    keyProjectSideView,
    keyProjectActionsCellRenderer
  },
  data() {
    return {
      selectedKeyProjectId: null,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        editable: false
      },
      gridApi: null,
      gridOptions: {
        getRowNodeId: (data) => {
          return data.id;
        }
      },
      context: { componentParent: this },
      columnDefs: [
        {
          headerName: 'Actions',
          field: 'id',
          width: 175,
          editable: false,
          sortable: false,
          cellRendererFramework: Vue.extend(keyProjectActionsCellRenderer)
        },
        {
          headerName: this.$t('KPU.KeyProject.ProjectName'),
          field: "projectName",
          filter:'agTextColumnFilter',
          width: 250
        },
        {
          headerName: this.$t('KPU.KeyProject.KeyProjectType'),
          field: "keyProjectTypeId",
          width: 200,
          filter:'agTextColumnFilter',
          valueGetter: (params) => {
            const keyProjectType = this.$store.state.kpu.keyProjectTypes.find(p => p.id === params.data.keyProjectTypeId);
            if (keyProjectType !== undefined)
              return keyProjectType.name;

            return "";
          }
        },
        {
          headerName: this.$t('KPU.KeyProject.District'),
          field: "district",
          filter:'agTextColumnFilter',
          width: 200
        },
        {
          headerName: this.$t('KPU.KeyProject.Country'),
          field: "country",
          filter:'agTextColumnFilter',
          width: 200
        },
        {
          headerName: this.$t('KPU.KeyProject.Property'),
          field: "property",
          filter:'agTextColumnFilter',
          width: 200
        },
        {
          headerName: this.$t('KPU.KeyProject.IsActive'),
          field: "isActive",
          width: 200,
          filter:'agTextColumnFilter',
          cellRendererFramework: "BooleanCell"
        }
      ],
      components: {
        keyProjectActionsCellRenderer,
        BooleanCell
      }
    };
  },
  computed: {
    keyProjectList() {
      return this.$store.state.kpu.keyProjects;
    }
  },
  methods: {
    refreshKeyProjectList() {
      this.$store.dispatch("kpu/fetchKeyProjects").then(() => {
        this.$refs.listCard.removeRefreshAnimation();
      });
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    deleteData(id) {
      this.$store.dispatch("kpu/removeKeyProject", id)
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: this.$t("Success"),
            text: this.$t("KPU.KeyProjectType.KeyProjectTypeDeleted")
          });
        });
    },
    editData(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    keyProjectUpdated(keyProject) {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("SaveSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });

      this.toggleDataSidebar(false);

      const rowNode = this.gridApi.getRowNode(keyProject.id);
      if (rowNode) {
        rowNode.setData(keyProject);
      }

      this.gridApi.applyTransaction({ update: [keyProject] });
    },

    keyProjectInserted() {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("InsertSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });
      this.toggleDataSidebar(false);
    }
  },
  created() {
    if (!moduleKpu.isRegistered) {
      this.$store.registerModule("kpu", moduleKpu);
      moduleKpu.isRegistered = true;
    }

    this.$vs.loading();
    this.$store.dispatch("kpu/fetchKeyProjectTypes").finally(() => {
      this.$vs.loading.close();
    });

  },
  mounted() {

    this.gridApi = this.gridOptions.api;

    if (!this.isMounted) {
      this.$refs.listCard.refreshcard();
    }

    this.isMounted = true;

  }
};
</script>